import {
  HEALTH_EXAM_SHORTEN_NEXT_RESULT_CODE,
  HEALTH_EXAM_SPECIAL_OBLIGATION_KEYS,
  type LegalObligationRow,
} from '@safetyhub/shared';

/** 「다음 1회 특수건강진단 주기 ½」 후보 한 줄 */
export interface SpecialExamShortenCandidate {
  obligationId: string;
  title: string;
}

/**
 * 「다음 1회 특수건강진단 주기 ½」(시행규칙 제202조②)을 걸 수 있는 행 — 그 현장 목록의 특수건강진단(6·12·24개월) 중 제외 아님 · 쓰기 막힘 없음
 * (권한 ∧ 서버 `writeBlock`) · `SHORTEN_NEXT` 결과 변형이 있는 행. 결과표 수령 기록(Q8 ⓑ)과 측정 초과 결과(결정 11)의 두 모달이 **이 한 벌**을 쓴다
 * (서버가 같은 판정을 다시 한다 — `SpecialExamShortenService`). ⚠️ «측정 공정×유해인자 → 특수 행» 대응이 모델에 없어 미리 고르지 않는다(사람이 고른다).
 * 순수 함수라 화면 spec이 `vi.mock`하는 API 모듈에 두지 않는다.
 */
export function specialExamShortenCandidates(
  rows: readonly LegalObligationRow[],
  canManage: boolean,
  titleOf: (row: LegalObligationRow) => string = (row) => row.title,
): SpecialExamShortenCandidate[] {
  if (!canManage) return [];
  return rows
    .filter(
      (r) =>
        HEALTH_EXAM_SPECIAL_OBLIGATION_KEYS.has(r.key) &&
        !r.exclusion &&
        !r.writeBlock &&
        r.intervalVariants.some((v) => v.selector === 'RESULT_FACT' && v.valueKeys.includes(HEALTH_EXAM_SHORTEN_NEXT_RESULT_CODE)),
    )
    .map((r) => ({ obligationId: r.obligationId, title: titleOf(r) }));
}
